import { render } from "./LearningUnit.vue?vue&type=template&id=2938c63e&scoped=true"
import script from "./LearningUnit.vue?vue&type=script&lang=js"
export * from "./LearningUnit.vue?vue&type=script&lang=js"

import "./LearningUnit.vue?vue&type=style&index=0&id=2938c63e&scoped=true&lang=stylus"

import exportComponent from "C:\\Users\\kmrtt\\20240208サイトデータ修正\\k_5\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2938c63e"]])

export default __exports__